import 'react';
import { jsx } from '@emotion/core';
import { ButtonGroup, Button } from '@appfolio/react-gears';
import { observer } from 'mobx-react';
import { DrawMode } from "../types/index.js";
import useStores from "../hooks/useStores.js";
import PdfToolbar from "./PdfToolbar.js";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var _ref = process.env.NODE_ENV === "production" ? {
  name: "1qxtz39",
  styles: "font-size:12px;"
} : {
  name: "1qxtz39",
  styles: "font-size:12px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var DrawablePdfToolbar = function DrawablePdfToolbar() {
  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore;

  return jsx(PdfToolbar, {
    drawable: true
  }, jsx("p", {
    className: "mb-2 text-muted",
    css: _ref
  }, "Select a field type and ", jsx("b", null, "click on"), " the template to insert the field."), jsx(ButtonGroup, {
    className: "mr-2"
  }, jsx(Button, {
    "data-testid": "textfield",
    active: pdfStore.drawMode === DrawMode.TextField,
    onClick: function onClick() {
      return pdfStore.setDrawMode(DrawMode.TextField);
    }
  }, "Custom Field"), jsx(Button, {
    "data-testid": "autofill",
    active: pdfStore.drawMode === DrawMode.Autofill,
    onClick: function onClick() {
      return pdfStore.setDrawMode(DrawMode.Autofill);
    }
  }, "Merge Field"), jsx(Button, {
    "data-testid": "checkbox",
    active: pdfStore.drawMode === DrawMode.Checkbox,
    onClick: function onClick() {
      return pdfStore.setDrawMode(DrawMode.Checkbox);
    }
  }, "Checkbox"), jsx(Button, {
    "data-testid": "signature",
    active: pdfStore.drawMode === DrawMode.Signature,
    onClick: function onClick() {
      return pdfStore.setDrawMode(DrawMode.Signature);
    }
  }, "Signature"), jsx(Button, {
    "data-testid": "initials",
    active: pdfStore.drawMode === DrawMode.Initials,
    onClick: function onClick() {
      return pdfStore.setDrawMode(DrawMode.Initials);
    }
  }, "Initials")));
};

DrawablePdfToolbar.displayName = "DrawablePdfToolbar";
var DrawablePdfToolbar$1 = observer(DrawablePdfToolbar);
export default DrawablePdfToolbar$1;